import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "EditItemModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_4 = {
  style: {"border-radius":"10px"},
  class: "modal-content p-5"
}
const _hoisted_5 = { class: "modal-header p-0 pb-4" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgb(236, 236, 236)"},
  class: "p-3 rounded"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"height":"fit-content","width":"fit-content","font-size":"18px","color":"#203972 !important"},
    class: "m-0 fas fa-pencil-alt"
  })
], -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"11px"},
  class: "m-0 fw-bold text-muted"
}, "Veja e altere detalhes do item do atendimento ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body p-0",
  id: "modalBody"
}
const _hoisted_13 = { class: "card d-flex gap-4 p-0 pt-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2 position-relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Código na loja: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"9px"}
}
const _hoisted_18 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2 position-relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Nome: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"9px"}
}
const _hoisted_21 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Status:", -1)
const _hoisted_23 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2 position-relative" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Valor final: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"9px"}
}
const _hoisted_26 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Valor original:", -1)
const _hoisted_28 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Desconto unitário:", -1)
const _hoisted_30 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Valor mão de obra:", -1)
const _hoisted_32 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Categoria:", -1)
const _hoisted_34 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Código dos agregados:", -1)
const _hoisted_36 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Checklist:", -1)
const _hoisted_38 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, "Tipo do item:", -1)
const _hoisted_40 = { class: "col-4 d-flex flex-column gap-1 px-3 pt-2 position-relative" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Qtd: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_42 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"9px"}
}
const _hoisted_43 = { class: "w-100 d-flex justify-content-end align-items-center gap-3" }
const _hoisted_44 = {
  key: 0,
  style: {"width":"fit-content","height":"fit-content"},
  class: "d-flex m-0 p-0 text-justify text-danger"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-pencil-alt"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_money = _resolveDirective("money")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss())),
                  class: "m-0 fw-bold fs-4 cor_texto_1"
                }, "Editar item do atendimento"),
                _hoisted_9
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.codItemLoja) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.codItemLoja]
                  ]),
                  (_ctx.triedToSave && !_ctx.item.codItemLoja)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "campo obrigatório!"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.nome) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.nome]
                  ]),
                  (_ctx.triedToSave && !_ctx.item.nome)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "campo obrigatório!"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.item.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.status) = $event)),
                    placeholder: "Selecione um status",
                    clearable: "",
                    class: "w-100 border-0 customSelect2"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusItem, (status, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          label: status,
                          value: status
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(status), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.valor) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.item.valor],
                    [_directive_money, _ctx.CurrencyValueMask]
                  ]),
                  (_ctx.triedToSave && !_ctx.item.valor)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "campo obrigatório!"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.valorOriginal) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.valorOriginal],
                    [_directive_money, _ctx.CurrencyValueMask]
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.desconto) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.desconto],
                    [_directive_money, _ctx.CurrencyValueMask]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.valorMo) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.valorMo],
                    [_directive_money, _ctx.CurrencyValueMask]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.categoria) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.categoria]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.codAgregados) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.codAgregados]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.campoCheckList) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.campoCheckList]
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.tipoItem) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.tipoItem]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("input", {
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    class: "p-2",
                    placeholder: "Digite...",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.qtd) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.item.qtd]
                  ]),
                  (_ctx.triedToSave && !_ctx.item.qtd || _ctx.item.qtd == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "campo obrigatório!"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_ctx.message)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_44, _toDisplayString(_ctx.message), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  type: "button",
                  text: "Excluir",
                  variant: "primary",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteItem()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  type: "button",
                  text: "Editar",
                  variant: "secondary",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveItem()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}